import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  addTicket,
  addTicketReplies,
  getTicketConfigStatus,
  getTicketList,
  getTicketRepliesList,
  getTicketTypeList,
  updateTicket,
  updateTicketReplies,
} from "./TicketRepo";
import { showToast } from "../../../utils/toastUtils";

// getTicketTypeList
export const useTicketTypeList = ({
  enable = false,
  params,
}: {
  enable: boolean;
  params?: string | any;
}) => {
  return useQuery({
    queryKey: ["GET_TICKET_TYPE_LIST", params],
    queryFn: () => getTicketTypeList(params),
    retry: false,
    enabled: enable,
  });
};

export const useTicketList = ({
  enable = false,
  params,
}: {
  enable: boolean;
  params?: string | any;
}) => {
  return useQuery({
    queryKey: ["GET_TICKET_LIST", params],
    queryFn: () => getTicketList(params),
    retry: false,
    enabled: enable,
  });
};

export const useTicketConfigStatus = ({
  enable = false,
}: {
  enable: boolean;
}) => {
  return useQuery({
    queryKey: ["GET_TICKET_CONFIG_LIST"],
    queryFn: getTicketConfigStatus,
    retry: false,
    enabled: enable,
  });
};

// addTicket
export const useAddTicket = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body?: any) => addTicket(body),
    onSuccess: () => {
      showToast.success("Add Ticket Successfully!");
      queryClient.invalidateQueries({ queryKey: ["GET_TICKET_LIST"] });
    },
    onError: (error: any) => {
      console.log(`Failed To Add Ticket  ${error.message}`);
      showToast.warning("Failed to Add Ticket!");
    },
  });
};

// updateTicket
export const useUpdateTicket = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, body }: { id?: string | number; body?: any }) =>
      updateTicket(id, body),
    onSuccess: () => {
      showToast.success("Update Ticket Successfully!");
      queryClient.invalidateQueries({ queryKey: ["GET_TICKET_LIST"] });
    },
    onError: (error: any) => {
      console.log(`Failed To Update Ticket  ${error.message}`);
      showToast.warning("Failed to Update Ticket!");
    },
  });
};

// getTicketRepliesList
export const useTicketRepliesList = ({
  enable = false,
  params,
}: {
  enable: boolean;
  params?: string | any;
}) => {
  return useQuery({
    queryKey: ["GET_TICKET_REPLIES_LIST", params],
    queryFn: () => getTicketRepliesList(params),
    retry: false,
    enabled: enable,
  });
};

// addTicketReplies
export const useAddTicketReplies = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body?: any) => addTicketReplies(body),
    onSuccess: (data) => {
      showToast.success(data?.data?.message);
      queryClient.invalidateQueries({ queryKey: ["GET_TICKET_REPLIES_LIST"] });
    },
    onError: (error: any) => {
      console.log(`Failed To Add Ticket Replies  ${error}`);
    },
  });
};

// updateTicketReplies
export const useUpdateTicketReplies = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body?: any) => updateTicketReplies(body),
    onSuccess: (data) => {
      showToast.success(data?.data?.message);
      queryClient.invalidateQueries({ queryKey: ["GET_TICKET_REPLIES_LIST"] });
    },
    onError: (error: any) => {
      console.log(`Failed To Update Ticket  ${error}`);
      // showToast.warning("Failed to Update Ticket!");
    },
  });
};
